export default __webpack_public_path__ + "4d9f61376d504dabe50187557b23352d.svg";